import { Component, OnInit, Output } from '@angular/core';
import { LocalStorageService } from '@pacifico/services/local/storage/local-storage.service';

@Component({
	selector: 'app-auth-page',
	templateUrl: './auth-page.component.html',
	styleUrls: ['./auth-page.component.scss']
})
export class AuthPageComponent implements OnInit {
	showTabDni = true;
	showHelp = false;
	showRecoveryPassword = false;
	user = { code: '', password: '', type: 'L' };
	showRemeberMe = true;
	@Output() codeUserRemenber = '';
	rememberMe = false;

	constructor(private _localStorageService: LocalStorageService) {}

	ngOnInit(): void {
		this.getUser();
		this.showTabDni = this.user.type == 'L';
		this.showRemeberMe = this._localStorageService.getItem('rememberme') ?? false;
	}

	clickTab(showDni: boolean): void {
		const type: string = showDni ? 'L' : 'S';
		this.getUser();
		if (this.showRemeberMe && this.user.type === type) {
			this.showTabDni = !showDni;
		}
		if (type === this.user.type && !this.showRemeberMe) {
			this.getUser();
		} else {
			this.user = { code: '', password: '', type: showDni ? 'L' : 'S' };
		}
	}

	clickShowHelp(): void {
		this.showHelp = !this.showHelp;
	}

	hideRecoveryPasswordEvent(show: boolean): void {
		this.showRecoveryPassword = show;
	}

	getUser(): void {
		const hide = '********';
		const lsUser = localStorage.getItem('user');

		if (lsUser !== null) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			this.user = JSON.parse(lsUser);
			const size = this.user.code.length;
			this.codeUserRemenber = this.user.code;
			this.user.code = hide.slice(0, size - 2) + this.user.code.slice(size - 2);
		}
	}
}
